import { observable, runInAction, action, computed } from "mobx";
import { ApiResult, FieldType, ViewModelBase } from "@shoothill/core";
import { InductionAdminInspectionModel } from "./InductionAdminInspectionModel";
import { AppUrls } from "../../../../../AppUrls";
import { ServerViewModel } from "../../../../../Globals/ViewModels/ServerViewModel";
// import { InspectionTypesLookupModel } from "./InspectionTypesLookupModel";
// import { InspectionsAndRelatedDTO } from "./InspectionsAndRelated";
// import { InspectionsViewModel } from "./InspectionsViewModel";
import { StoresInstance } from "../../../../../Globals/Stores";
import { InductionAdminInspectionListModel } from "./InductionAdminInspectionListModel";

export class InductionAdminInspectionViewModel extends ViewModelBase<InductionAdminInspectionModel> {
    public server: ServerViewModel = new ServerViewModel();
    public projectId: string = "";
    //@observable public inspectionFormType: InspectionTypesLookupModel | null = null;
    //@observable public inspectionFormTypes: any = [];
    //@observable public showAddForm: boolean = false;
    //@observable public inspectionViewModel: InductionAdminInspectionViewModel = new InductionAdminInspectionViewModel(new InductionAdminInspectionModel());
    @observable public inspectionsListModels: InductionAdminInspectionListModel[] = [];
    constructor(inductionUserId: string) {
        super();
        this.setDecorators(InductionAdminInspectionModel);
        this.loadInspectionAndRelated(inductionUserId);
    }

    // @action
    // public setInspectionForm = (type: InspectionTypesLookupModel | null) => {
    //     this.inspectionFormType = type;
    // };

    // @computed
    // public get getInspectionTypeName(): string {
    //     if (this.inspectionViewModel && this.inspectionViewModel.model.inspectionTypeName) {
    //         return this.inspectionViewModel.model.inspectionTypeName;
    //     } else if (this.inspectionFormType) {
    //         return this.inspectionFormType.displayName;
    //     }

    //     return "";
    // }

    // public loadRelated = (): Promise<void> => {
    //     return this.server.query<InspectionsAndRelatedDTO>(
    //         () => this.Get(`${AppUrls.Server.Projects.Construction.Inspections.LoadInspectionsAndRelated}?projectId=${this.projectId}`),
    //         (result) => {
    //             runInAction(() => {
    //                 this.inspectionFormTypes.replace(InspectionTypesLookupModel.fromDtos(result.inspectionTypes));
    //                 this.inspectionsListModels = [];
    //                 for (const inspection of result.inspections) {
    //                     let model = new InspectionsListModel();
    //                     model.fromDto(inspection);
    //                     this.inspectionsListModels.push(model);
    //                 }
    //             });
    //         },
    //     );
    // };

    public loadInspectionAndRelated = async (id: string): Promise<ApiResult<any>> => {
        this.setIsLoading(true);
        let params = { id: id };

        const apiResult = await this.Post<any>(AppUrls.Server.Induction.GetInductionInspectionsByInductionUserId, params);
        if (apiResult) {
            if (apiResult.wasSuccessful) {
                runInAction(() => {
                    //this.inspectionFormTypes.replace(InspectionTypesLookupModel.fromDtos(result.inspectionTypes));
                    this.inspectionsListModels = [];
                    for (const inspection of apiResult.payload.inspections) {
                        let model = new InductionAdminInspectionListModel();
                        model.fromDto(inspection);
                        this.inspectionsListModels.push(model);
                    }
                });
            } else {
                console.log(apiResult.errors);
            }
        }
        this.setIsLoading(false);
        return apiResult;
    };

    // @action
    // public handleRowClick = (e: any, rowData: InspectionsListModel) => {
    //     this.showAddForm = true;

    //     let model = new InspectionsModel();
    //     model.id = rowData.id;
    //     model.projectId = this.projectId;

    //     this.inspectionViewModel = new InspectionsViewModel(model);
    // };

    // @action
    // public showInspectionFormForSiteTablet = (inspectionTypeId: string) => {
    //     this.showAddForm = true;
    //     let model = new InspectionsModel();
    //     model.projectId = this.projectId;
    //     model.inspectionTypeId = inspectionTypeId;
    //     this.inspectionViewModel = new InspectionsViewModel(model);
    // };

    // @action
    // public cancelInspectionForm = () => {
    //     if (StoresInstance.Domain.AccountStore.isSiteTablet) {
    //         this.history.push(AppUrls.Client.Project.SiteTablet.Menu);
    //     } else if (StoresInstance.Domain.AccountStore.isInductionUser) {
    //         this.history.push(AppUrls.Client.Project.InductionUser.Menu);
    //     } else {
    //         this.showAddForm = false;
    //         this.inspectionViewModel = new InspectionsViewModel(new InspectionsModel());
    //         this.setInspectionForm(null);
    //         this.loadRelated();
    //     }
    // };

    public async isFieldValid(fieldName: keyof FieldType<InductionAdminInspectionModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
